export default {
  update: (data) => ({
    ...data,
  }),
}
